import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main>
      <div className="contained-wide widescreen:px-60 px-16">
        <h1 className="h1 mb-32">Shipping Information</h1>
        <div className="flex flex-col">
          <div className="tablet:flex-row tablet:mb-60 mb-16 flex flex-col">
            <div className="tablet:basis-1/2 tablet:mb-0 tablet:mr-40 mb-40 basis-full">
              <h2 className="tablet:mb-20 h2 mb-10">Preparing Your Order</h2>
              <p className="body">
                Preparation time depends on the design and selected options.
                The estimate shown during checkout or in your order confirmation
                is the estimate that applies to your purchase.
              </p>
            </div>
            <div className="tablet:basis-1/2 basis-full">
              <h2 className="tablet:mb-20 h2 mb-10">Delivery</h2>
              <p className="body mb-20">
                Available destinations, delivery services, charges, and expected
                transit times are displayed before you complete checkout.
              </p>
              <p className="body">
                Delivery estimates are not guarantees. Carrier delays, customs,
                holidays, weather, and an incomplete address may affect arrival.
              </p>
            </div>
          </div>
          <div>
            <h2 className="h2 tablet:mb-32 mb-16">Tracking &amp; Support</h2>
            <p className="body">
              When tracking is available, it will be sent to the contact address
              used for the order. For help, email{" "}
              <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>{" "}
              with your order number.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Delivery;
